import React from 'react';
import { View } from 'react-native';
import CardFactory from './CardFactory';
import { Credential } from '../../../../types/credentials';

interface CardIconProps {
  credential: Credential;
}

/**
 * @description Card icon component
 * @param {CardIconProps} { credential }
 * @return {React.FC}
 */
const CardIcon: React.FC<CardIconProps> = ({ credential }) => {
  const logo = CardFactory.createLogo(credential);

  if (logo) {
    return <img src={logo} style={{ width: 48, height: 48, objectFit: 'cover' }} />;
  }

  return (
    <View
      style={{
        width: 48,
        height: 48,
        opacity: 0.75,
        borderWidth: 1,
        borderStyle: 'dashed',
        borderRadius: 8,
        borderColor: '#fff'
      }}
    />
  );
};

export default CardIcon;
